import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { CanDeactivateGuard } from '@unity/utils/types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeactivateGuard implements CanDeactivate<unknown> {
  public canDeactivate(
    component: CanDeactivateGuard,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    const bypass = nextState.root.queryParamMap.has('success');
    if (bypass) {
      return true;
    }
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
